import { Box, Card, CardHeader } from '@mui/material'
import { memo } from 'react'

import Text from '../shared/text/Text'

const Note = ({ t }) => {
  return (
    <Card>
      <CardHeader
        title={t('earn-via.note')}
        subheader={t('games.important-note.title')}
      />
      <Box px={3} pt={1} pb={3}>
        <Box component='ul' color='text.secondary' pl={2.8} pb={1}>
          {t('games.important-note.items', { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>
                <Text label={item} />
              </li>
            )
          )}
        </Box>
        <Text
          label={t('games.important-note.manipulating-system')}
          color='text.secondary'
          sx={{ pb: 1 }}
        />
        <Text label={t('games.important-note.footer')} color='text.secondary' />
      </Box>
    </Card>
  )
}

export default memo(Note)
